import type {
  DataCollectionRequestDetails,
  DataCollectionRequestInfo,
  DataCollectionRequestTemplateVersion,
} from "../../../../api/types/dataCollectionTypes";
import type { ObjectAccessCategory } from "../../../../api/types/objectTypes";

type CategoriesContainer =
  | DataCollectionRequestTemplateVersion
  | DataCollectionRequestInfo
  | DataCollectionRequestDetails;

export const getDataRequestTemplateCategoryId = (container: CategoriesContainer): string =>
  container.auditory === "Internal"
    ? (container.internalUserPermissionCategories[0] ?? "")
    : (container.contactCategories[0] ?? "");

export const getDataRequestTemplateCategoryName = (
  container: CategoriesContainer,
  allCategories: ObjectAccessCategory[]
): string => {
  const categoryId = getDataRequestTemplateCategoryId(container);
  return categoryId ? (allCategories.find((c) => c.id === categoryId)?.name ?? "") : "";
};
